import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import moment from 'moment';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';
import { ConfirmServiceService } from '../confirm-dailog-token/confirm-service.service';
import { ConfirmDailogTokenComponent } from '../confirm-dailog-token/confirm-dailog-token.component';
declare var $: any;
import { User } from '../../models/user.model';

import { ChangeDetectorRef } from '@angular/core';
import {
  BsDatepickerModule,
  BsDatepickerConfig,
} from 'ngx-bootstrap/datepicker';
declare var $: any;
import { Country } from 'country-state-city';

import { UserRoleEnum } from '../../enums/user-role-enum';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  AbstractControl,
  ValidatorFn,
  ValidationErrors,
  FormControl,
} from '@angular/forms';

@Component({
  selector: 'profile',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ConfirmDailogTokenComponent,
    BsDatepickerModule,
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
})
export class ProfileComponent implements OnInit {
  countryCodes: Array<{ code: string; name: string; dial_code: string }> = [];
  defaultCountryCode = '+91';
  isDateSelected = false;
  datePickerConfig: Partial<BsDatepickerConfig>;
  token: string = 'e975995-1b44-4242-89b8-78b0947ccc26de';
  expiryInfo: any = '0 days 0 Hours 0 Minutes';
  profileImangeName: any;
  profileForm: FormGroup;
  today: any = moment().format('YYYY-MM-DD');
  today1: Date = new Date();
  isModalVisible: boolean = true;
  passwordForm: FormGroup;
  authUser = localStorage.getItem('FLOCurrentUser');
  loginedUser = this.authUser ? JSON.parse(this.authUser) : '';
  fileError: string | null = null;
  imagePreview: string | ArrayBuffer | null = null;
  message: any;
  loggedUser: User = new User();
  isProjectAdmin: boolean = false;
  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || '';
      if (value.trim().length === 0) {
        return { whitespace: true };
      }
      return null;
    };
  }
  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private toastr: ToastrService,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private readonly confirmServiceService: ConfirmServiceService,
    private authService: AuthService
  ) {
    this.datePickerConfig = {
      dateInputFormat: 'DD-MM-YYYY',
      maxDate: this.today1,
    };
    this.profileForm = this.fb.group({
      username: [
        { value: '', disabled: true },
        [Validators.required, this.noWhitespaceValidator()],
      ],
      email: new FormControl({ value: '', disabled: true }, [
        Validators.required,
        (control: AbstractControl): ValidationErrors | null => {
          const emailPattern =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          const emailValid = emailPattern.test(control.value);
          return !emailValid ? { invalidEmail: true } : null;
        },
      ]),

      firstName: ['', [Validators.required, this.noWhitespaceValidator()]],
      lastName: ['', [Validators.required, this.noWhitespaceValidator()]],
      dob: ['', Validators.required],
      gender: ['', Validators.required],
      contactInfo: ['', Validators.required],
      phoneNumber: new FormControl(''),
      countryCode: ['', Validators.required],
      ConsumerPhone: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{10}$')],
      ],
      profileImage: [null, [Validators.required, this.imageFileValidator()]],
      profile_image_filename: [''],
      isPforileImageChange: [false],
      password: [{ value: '**********', disabled: true }],
    });

    this.passwordForm = this.fb.group(
      {
        oldPassword: ['', Validators.required],
        newPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/
            ),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.CurrentUserValue;
    if (this.loggedUser.role === UserRoleEnum.ProjectAdmin) {
      this.isProjectAdmin = true;
      this.getSecurityTokenDetails();
    }
    this.loadAllCountryCode();
    this.getProfileDetails();
    this.profileForm = this.fb.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      dob: ['', [Validators.required, this.validateDateOfBirth()]],
      gender: ['', Validators.required],
      contactInfo: ['', Validators.required],
      profileImage: [''],
    });
  }
  loadAllCountryCode() {
    const countryData = Country.getAllCountries();
    this.countryCodes = countryData.map((country) => ({
      name: country.name,
      dial_code: country.phonecode,
      code: country.isoCode,
    }));
  }
  setDefaultCountryCode() {
    this.defaultCountryCode =
      this.countryCodes.find((country) => country.code === 'IN')?.dial_code ||
      '+91';

    this.profileForm.patchValue({
      countryCode: this.defaultCountryCode,
    });
  }
  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || '';
      const phonePattern = /^[0-9]\d{10}$/;
      if (!phonePattern.test(value)) {
        return { invalidNumber: true };
      }

      return null;
    };
  }
  getProfileDetails() {
    let clause = {
      id: this.loginedUser.id,
      role: this.loggedUser.role,
    };
    this.userService.getUser(clause).subscribe(
      (response) => {
        this.spinner.hide();
        const userData = response.data;
        this.imagePreview =
          environment.AwsS3BucketUrl + userData.profile_image_filename;
        this.profileImangeName = userData.profile_image_actual_filename;
        if (response.data.phone_no && response.data.phone_no.includes(',')) {
          const [countryCode, phoneNumber] = response.data.phone_no.split(',');
          this.profileForm.patchValue({
            countryCode: countryCode,
            ConsumerPhone: phoneNumber,
          });
        } else {
          this.profileForm.patchValue({
            countryCode: '',
            ConsumerPhone: response.data.phone_no ? response.data.phone_no : '',
          });
        }

        this.profileForm.patchValue(
          { gender: userData.gender ? userData.gender.toLowerCase() : '' },
          { emitEvent: false }
        );
        this.profileForm.patchValue({
          username: userData.username,
          email: userData.email,
          firstName: userData.firstname,
          lastName: userData.lastname,
          dob: userData.dob ? userData.dob : '',
          contactInfo: userData.contact_info,
          profileImage: userData.profile_image_filename,
          profile_image_filename: userData.profile_image_actual_filename,
        });
      },
      (error) => {
        console.error(error);
      }
    );
  }
  onDateSelected() {
    if (!this.isDateSelected) {
      this.isDateSelected = true;
      this.cdr.detectChanges();
    }
  }
  formatDate(dateString: string): string {
    return moment(dateString).format('YYYY-MM-DD');
  }
  oncancel = (): void => {
    this.router.navigateByUrl('/home');
  };
  onSubmit() {
    if (this.profileForm.valid) {
      let countryCode = this.profileForm.get('countryCode')?.value;

      const consumerPhone = this.profileForm.get('ConsumerPhone')?.value;
      const phoneNumber = countryCode + ',' + consumerPhone;
      const selectedDate = new Date(this.profileForm.get('dob')?.value);
      const formattedDate = `${selectedDate.getFullYear()}-${String(
        selectedDate.getMonth() + 1
      ).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;
      const formData = new FormData();
      formData.append(
        'isPforileImageChange',
        this.profileForm.get('isPforileImageChange')?.value
      );
      formData.append('id', this.loginedUser.id);
      formData.append('username', this.profileForm.get('username')?.value);
      formData.append('email', this.profileForm.get('email')?.value);
      formData.append('firstName', this.profileForm.get('firstName')?.value);
      formData.append('lastName', this.profileForm.get('lastName')?.value);
      formData.append('dob', formattedDate);
      formData.append('gender', this.profileForm.get('gender')?.value);
      formData.append(
        'contactInfo',
        this.profileForm.get('contactInfo')?.value
      );
      formData.append('phoneNumber', phoneNumber);

      const profileImage = this.profileForm.get('profileImage')?.value;
      if (profileImage) {
        formData.append('profileImage', profileImage);
        formData.append('profile_image_filename', profileImage.name);
      }

      this.spinner.show();

      this.userService.updateProfile(formData).subscribe(
        (response: any) => {
          this.spinner.hide();
          this.toastr.success(response.message, 'User Profile');
          this.updateAuthUser(response.data);
          this.router.navigateByUrl('/home');
        },
        (err: any) => {
          this.spinner.hide();
          this.toastr.error(err.error.error, 'User Profile');
          console.log(err);
        }
      );
    } else {
      this.profileForm.markAllAsTouched();
    }
  }
  private updateAuthUser(profile_pic: any): void {
    let authUser = {
      ...this.loginedUser,
      first_name: this.profileForm.get('firstName')?.value,
      last_name: this.profileForm.get('lastName')?.value,
      full_name:
        this.profileForm.get('firstName')?.value +
        ' ' +
        this.profileForm.get('lastName')?.value,
    };
    if (this.profileForm.get('isPforileImageChange')?.value == true) {
      authUser.profile_pic = environment.AwsS3BucketUrl + profile_pic;
    }
    localStorage.setItem('FLOCurrentUser', JSON.stringify(authUser));
    $('#dropdownMenuLink').text(authUser.full_name);
    $('#imgProfileImage').attr('src', authUser.profile_pic);
    window.dispatchEvent(new Event('storage'));
  }
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

      if (!validImageTypes.includes(file.type)) {
        this.fileError = 'Please upload a valid image file (JPEG, PNG, GIF).';
        this.profileForm.get('profileImage')?.setValue(null);
        this.imagePreview = null;
      } else {
        this.fileError = null;
        this.profileImangeName = file.name;
        this.profileForm.get('profileImage')?.setValue(file);
        this.profileForm.get('profile_image_filename')?.setValue(file.name);
        this.profileForm.get('isPforileImageChange')?.setValue(true);
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result;
        };
        reader.readAsDataURL(file);
      }
    }
  }
  getControl(controlName: string) {
    return this.profileForm.get(controlName);
  }

  validateDateOfBirth() {
    const selectedDate = this.profileForm.get('dob')?.value;
    this.today = moment().format('YYYY-MM-DD');
    if (moment(selectedDate).isAfter(this.today)) {
      this.profileForm.get('dob')?.setErrors({ invalidDate: true });
    }
  }
  getControlForm(controlName: string) {
    return this.passwordForm.get(controlName);
  }

  submitPasswordChange() {
    if (this.passwordForm.valid) {
      this.spinner.show();
      const passwordData = this.passwordForm.value;
      this.userService.changePassword(passwordData).subscribe(
        (response) => {
          this.spinner.hide();
          this.closeModal();
          this.toastr.success('Password updated successfully', 'User Profile');

          this.logOut(response.data.id);
        },
        (error) => {
          this.spinner.hide();
          this.toastr.error(error.error.message, 'User Profile');
          console.error(error);
        }
      );
    } else {
      this.passwordForm.markAllAsTouched();
    }
  }
  cancelPasswordChange() {
    this.passwordForm.reset({
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    });
  }
  logOut(userId: string): void {
    this.spinner.show();
    this.authService.userLogout(userId).subscribe(
      (response) => {
        this.spinner.hide();
        this.router.navigate(['/login']);
      },
      (error: any) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }

  closeModal() {
    this.isModalVisible = false;
    this.passwordForm.reset();
    $('#changePasswordModal').modal('hide');
    this.passwordForm.reset();
  }

  passwordMatchValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    const password = control.get('newPassword')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;

    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  imageFileValidator() {
    return (control: any) => {
      const file = control.value;
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
      if (file && file.type && !validImageTypes.includes(file.type)) {
        return { invalidFileType: true };
      }
      return null;
    };
  }

  copyToken(): void {
    let clause = {
      id: this.loginedUser.id,
    };
    this.userService.getSecqurityToken(clause).subscribe(
      (response) => {
        this.spinner.hide();
        if (response.data !== '') {
          this.token = response.data?.security_token;
          const tokenExpiry = response.data?.token_expiry;

          if (tokenExpiry) {
            navigator.clipboard.writeText(this.token);
            this.toastr.success(
              'Security token copied to clipboard',
              'User Profile'
            );
            const expiryDate = new Date(tokenExpiry);
            const now = new Date();

            if (expiryDate.getTime() > now.getTime()) {
              const diffMilliseconds = expiryDate.getTime() - now.getTime();
              const diffSeconds = Math.floor(diffMilliseconds / 1000);

              const days = Math.floor(diffSeconds / (3600 * 24));
              const hours = Math.floor((diffSeconds % (3600 * 24)) / 3600);
              const minutes = Math.floor((diffSeconds % 3600) / 60);
              const seconds = diffSeconds % 60;

              if (days > 0) {
                this.expiryInfo = `The token will expire in ${days}d ${hours}h ${minutes}m ${seconds}s`;
              } else {
                this.expiryInfo = `The token will expire in ${hours}h ${minutes}m ${seconds}s`;
              }
            } else {
              this.expiryInfo = 'The token has expired.';
            }
          } else {
            this.expiryInfo = 'Token expiry time not available.';
          }
        } else {
          this.token = '';
          this.expiryInfo = 'Token expiry time not available.';
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  generateToken(): void {
    let clause = {
      id: this.loginedUser.id,
    };
    this.userService.checkSecqurityTokenValidation(clause).subscribe(
      (response) => {
        this.spinner.hide();
        if (response.data !== '') {
          this.confirmServiceService.showConfirm(
            response.message,
            () => {
              this.generateSecqurityToken();
            },
            () => {}
          );
        } else {
          this.generateSecqurityToken();
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
  generateSecqurityToken() {
    let clause = {
      id: this.loginedUser.id,
    };
    this.userService.createSecqurityToken(clause).subscribe(
      (response) => {
        this.spinner.hide();
        this.getSecurityTokenDetails();
      },
      (error) => {
        this.toastr.error(error.error.message, 'User Profile');
        console.error(error);
      }
    );
  }

  getSecurityTokenDetails() {
    let clause = {
      id: this.loginedUser.id,
    };
    this.userService.getSecqurityToken(clause).subscribe(
      (response) => {
        this.spinner.hide();
        if (response.data !== '') {
          this.token = response.data?.security_token;
          const tokenExpiry = response.data?.token_expiry;

          if (tokenExpiry) {
            const expiryDate = new Date(tokenExpiry);
            const now = new Date();

            if (expiryDate.getTime() > now.getTime()) {
              const diffMilliseconds = expiryDate.getTime() - now.getTime();
              const diffSeconds = Math.floor(diffMilliseconds / 1000);

              const days = Math.floor(diffSeconds / (3600 * 24));
              const hours = Math.floor((diffSeconds % (3600 * 24)) / 3600);
              const minutes = Math.floor((diffSeconds % 3600) / 60);
              const seconds = diffSeconds % 60;

              if (days > 0) {
                this.expiryInfo = `The token will expire in ${days}d ${hours}h ${minutes}m ${seconds}s`;
              } else {
                this.expiryInfo = `The token will expire in ${hours}h ${minutes}m ${seconds}s`;
              }
            } else {
              this.expiryInfo = 'The token has expired.';
            }
          } else {
            this.expiryInfo = 'Token expiry time not available.';
          }
        } else {
          this.token = '';
          this.expiryInfo = 'Token expiry time not available.';
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
}
